export default "__VITE_ASSET__f916a7b8__"